export const ROUTES = {
  HOME: '/',
  HOME_ROI_1: '/roi/home',
  AUTO_ROI_1: '/roi/auto',
};
